import { render, staticRenderFns } from "./ResultByRivalDetailModal.vue?vue&type=template&id=58e4c6a0"
import script from "./ResultByRivalDetailModal.vue?vue&type=script&lang=js"
export * from "./ResultByRivalDetailModal.vue?vue&type=script&lang=js"
import style0 from "./ResultByRivalDetailModal.vue?vue&type=style&index=0&id=58e4c6a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports